
import { COD_RETAIL_CONFIGURATION } from "@/app/infrastructures/misc/RolePermission";
import {
  checkRolePermission,
  formatDate,
  IS_SENDER_ACCOUNT,
  parsingErrorResponse,
  formatByCountry
} from "@/app/infrastructures/misc/Utils";
import { CodConfigurationController } from "@/app/ui/controllers/CodConfigurationController";
import { DetailCodConfigurationRetail } from "@/domain/entities/CodConfiguration";
import { FlagsCodConfiguration } from "@/feature-flags/flags-cod-configuration";
import { Vue } from "vue-class-component";

class DetailInternational extends Vue {
  detailData = new DetailCodConfigurationRetail();
  isLoading = false;
  isError = false;
  errorCause = "";

  mounted() {
    this.getDetail();
  }

  get getTitle() {
    return this.$t(this.detailData.ccoName);
  }

  get id(): number {
    return Number(this.$route.params.id);
  }

  goBack() {
    this.$router.push(`/tarif/konfigurasi-cod-retail`);
  }

  async getDetail() {
    this.isLoading = true;
    try {
      this.detailData = await CodConfigurationController.getDetailCodConfigurationRetail(
        this.id
      );
      this.isError = false;
    } catch (error) {
      this.errorCause = parsingErrorResponse(error).type;
      this.isError = true;
    } finally {
      this.isLoading = false;
    }
  }

  get productType() {
    return this.detailData.ccoProductType.split(",");
  }

  get convertCreatedAt() {
    return formatDate(this.detailData.ccoCreatedAt);
  }

  get convertUpdatedAt() {
    return formatDate(this.detailData.ccoUpdatedAt);
  }

  goToEdit(id: any) {
    this.$router.push(`/tarif/konfigurasi-cod-international/${id}/edit`);
  }

  get isSenderAcount() {
    return IS_SENDER_ACCOUNT;
  }

  get isEditAble() {
    return FlagsCodConfiguration.permission_redirect_cod_international_configuration_edit.isEnabled();
  }

  formatItemPrice(val: number, country: string): string {
    const hasFraction = (num: number) => {
      return typeof num === 'number' && !Number.isInteger(num);
    }
    return formatByCountry(val, {
      type: "money",
      country: country,
      fractionDigits: hasFraction(val) ? 2 : 0,
      minFractionDigits: hasFraction(val) ? 2 : 0
    });
  }
}
export default DetailInternational;
